import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.locale('en-us');
dayjs.extend(isoWeek);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

export const USER_TIMEZONE = dayjs.tz.guess();
